import { HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { META_REDUCERS, StoreModule } from '@ngrx/store';

import { AuthModule } from '@shared/auth';
import { ErrorTracking, PerformanceTracking } from '@shared/tracking';

import { ApiHttp } from './api-http.service';
import { Datastore } from './datastore';
import { DATASTORE_CONFIG } from './datastore.config';
import { DatastoreConfig } from './datastore.interface';
import { errorHandlerReducerFactory } from './error-handler.reducer';
import { MessagesEffect } from './message/messages.effect';
import { RequestDataEffect } from './request-data.effect';
import { sessionStorageSyncFactory } from './session-storage-sync.reducer';
import { reducers } from './store';
import { storeFreezeReducerFactory } from './store-freeze.reducer';
import { WebSocketService } from './websocket';

// FIXME: use MetaReducer[] as the return type once
// https://github.com/ngrx/platform/pull/270 has been released
export function getMetaReducers(
  errorTracking: ErrorTracking,
  performanceTracking: PerformanceTracking,
  config: DatastoreConfig,
): any[] {
  const metaReducers = [
    errorHandlerReducerFactory(errorTracking),
    sessionStorageSyncFactory(performanceTracking),
  ];
  if (config.enableStoreFreeze) {
    metaReducers.push(storeFreezeReducerFactory(performanceTracking));
  }
  return metaReducers;
}

@NgModule({
  imports: [
    HttpClientModule,
    AuthModule,
    StoreModule.forRoot(reducers),
    EffectsModule.forRoot([]),
    EffectsModule.forFeature([MessagesEffect, RequestDataEffect]),
  ],
  providers: [ApiHttp, WebSocketService],
})
export class DatastoreModule {
  static initialize(config: DatastoreConfig): ModuleWithProviders {
    return {
      ngModule: DatastoreModule,
      providers: [
        Datastore,
        { provide: DATASTORE_CONFIG, useValue: config },
        {
          provide: META_REDUCERS,
          deps: [ErrorTracking, PerformanceTracking, DATASTORE_CONFIG],
          useFactory: getMetaReducers,
        },
      ],
    };
  }
}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/pl/webapp/src/app/@shared/datastore/datastore.module.ts